<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <Regions :countryId="countryId" />
    </div>
</template>

<script>
import currentUserQuery from '@views/Regions/Browse/queryCurrentUser.graphql';

import Regions from '../Regions/Browse.vue';

export default {
  name: 'RegionsContainer',
  props: {
    countryId: {
      required: true,
    },
  },
  components: {
    Regions,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['developer', 'admin', 'association'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
